import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { MappingData } from "types/models/support/SupportApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: MappingData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {   
  const getStatusColor = () => {
    if (data.status) {
      return "#43C888"; 
    } else {
      return "#F84E4E"; 
    }
  };


  return (
    <TableRow key={data.CRMCategory} className="item-hover">
      <StyledTableCell align="left">{data.sNo}</StyledTableCell>
      <StyledTableCell component="th" scope="row">
        <Box
          sx={{
            color: "black", 
            borderBottom: "none",
            display: "inline-block",
          }}
        >
          {data.CRMCategory}
        </Box>
      </StyledTableCell>
    
      <StyledTableCell align="left">{data.clientCategory}</StyledTableCell>
      <StyledTableCell align="left">{data.conditions}</StyledTableCell>
      <StyledTableCell align="left">
        <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
